export const AGENDA_STATUS = {
    "RespondedByAdmin": "Responded",
    "Sent": "Shared",
    "RespondedByExpert": "Responded",
    "Declined": "Declined",
    "Responded": "Responded",
}

export enum AgendaStatus {
    SENT = "Sent",
    DECLINED = "Declined",
    RESPONDED = "Responded",
}

export enum INVITATION_STATUS {
    INVITED = "Invited",
    ACCEPTED = "Accepted",
    DECLINED = "Declined",
}

export type TExpert_Invitation = INVITATION_STATUS | null